export var HUNDRED = 100;
export var THOUSDAND = 1000;
export var ATTRIBUTE_VALUES;
(function (ATTRIBUTE_VALUES) {
  ATTRIBUTE_VALUES["CAR_VALUE"] = "car_value";
  ATTRIBUTE_VALUES["DOWNPAYMENT"] = "downpayment";
  ATTRIBUTE_VALUES["LOAN_DURATION"] = "loan_duration";
})(ATTRIBUTE_VALUES || (ATTRIBUTE_VALUES = {}));
export var CF_PAGES;
(function (CF_PAGES) {
  CF_PAGES["CALCULATOR"] = "cf_calculator";
  CF_PAGES["LEAD_GEN_FORM"] = "cf_lead_form";
})(CF_PAGES || (CF_PAGES = {}));
export var FLOW_TYPES;
(function (FLOW_TYPES) {
  FLOW_TYPES["HOME_CF"] = "home_cf";
})(FLOW_TYPES || (FLOW_TYPES = {}));
export var SLIDERS;
(function (SLIDERS) {
  SLIDERS["CAR"] = "car";
  SLIDERS["HITCH"] = "hitch";
})(SLIDERS || (SLIDERS = {}));
export var CURRENCY_SYMBOLS = {
  pre: '$',
  post: ''
};